module.exports = __webpack_public_path__ + "img/zsdxdsfu.bd9108de.png";